export const INIT = "init";
export const VERIFIED = "verified";
export const AIRLINE_SELECT = "airline-select";
export const HOLD = "hold";
